export const SCRATCH_CODE_LENGTH = 6;
export const CAPTCHA_MAX_LENGTH = 6;

export enum ACCESS_BLOCKED_REASONS {
  PASSWORD = 'password',
  SMS = 'sms',
  SCRATCH = 'scratch',
  RECOVER = 'recover',
}

export enum LOGIN_TYPES {
  BY_PHONE = 'phone',
  BY_USERNAME = 'username',
}
